import styled from 'styled-components';

export const CheckboxStyle = styled.input`
  opacity: 0;
  margin: 0 0 5px 0;

  + label::after {
    content: none;
  }

  &:checked + label::after {
    content: '';
  }

  &:checked + label::before {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const LabelStyle = styled.label`
  position: relative;
  padding-left: 20px;
  box-sizing: border-box;
  margin: 0 0 0 -15px;

  &:hover {
    &::before {
      background-color: ${({ theme }) => theme.palette.action.hover};
    }
  }

  &::before {
    height: 20px;
    width: 20px;
    border: 0;
    border-radius: 2px;
    left: 0;
    top: 0;
    background-color: ${({ theme }) => theme.palette.grey.A200};
  }

  &::after {
    height: 5px;
    width: 10px;
    border-left: 2px solid;
    border-bottom: 2px solid;
    transform: rotate(-45deg);
    left: 4px;
    top: 5px;
    border-color: ${({ theme }) => theme.palette.divider};
  }

  &::before,
  &::after {
    position: absolute;
    content: '';
    display: inline-block;
    transition: background-color 0.1s;
  }
`;
